
const TOGGLE_SIDEBAR = (state) => {
  state.sidebarIsOpen = !state.sidebarIsOpen;
};

const ADD_SHAPE = (state, payload) => {
  state.testShapes.push(payload)
};

const SET_CURRENT_IMAGE = (state, payload) => {
  state.currentImage = payload;
};

const REMOVE_ALL_SHAPE = (state) => {
  state.testShapes = [];
};

const ADD_SEATS = (state, payload) => {
  state.testSeats.push(payload)
};

const SET_CURRENT_SEAT_IMAGE = (state, payload) => {
  state.currentSeatImage = payload;
};

export default {
  TOGGLE_SIDEBAR,
  ADD_SHAPE,
  SET_CURRENT_IMAGE,
  REMOVE_ALL_SHAPE,
  ADD_SEATS,
  SET_CURRENT_SEAT_IMAGE
}